import React from 'react';

function Intro() {
  return (
    <section className="intro-section">
      <div className="container">
        <p className="intro-text">
          Sloomweep is an independent music label focusing on stoner, psychedelic, doom, and sludge sounds from across the globe.
        </p>
      </div>
    </section>
  );
}

export default Intro;

